module.exports = __webpack_public_path__ + "static/media/sign.3898d617.svg";